import React from 'react';
import './PostcodeField.scss';

const PostCodeField = ({
  input,
  placeholder,
  meta,
  type,
  disabled,
  onPostcodeChange,
}) => {
  const handlePostcodeChange = (value) => {
    if (onPostcodeChange) {
      onPostcodeChange(value.target.value);
    }
    input.onChange(value);
  };

  return (
    <div className={meta && meta.submitFailed && meta.error ? 'has-error' : ''}>
      <input
        className="form-control"
        disabled={disabled}
        {...input}
        onChange={handlePostcodeChange}
        placeholder={placeholder || ''}
        type={type}
      />
      {meta && meta.submitFailed && meta.error && (
        <span className="input-error">{meta.error}</span>
      )}
    </div>
  );
};

export default PostCodeField;
